import { Row, Col, FormGroup, ListGroup } from 'react-bootstrap';
import React, { Component, Fragment } from 'react';
import FormularioPadrao from '../FormularioPadrao';
import Label from '../../components/Label';
import TextInput from '../../components/TextInput';
import EmailInput from '../../components/EmailInput';
import SubCadastro from '../../components/SubCadastro';
import CheckBox from '../../components/CheckBox';
import ServicoDeNotificacaoController from '../../controllers/Empresa/ServicoDeNotificacaoController';
import { updateState } from '../../utils/Functions';
import TimeInput from '../../components/TimeInput';
import IntegerInput from '../../components/IntegerInput';
import Select from '../../components/Select';
import { FlexCol, FlexRow } from '../../components/FlexItems';
import IconButton from '../../components/IconButton';
import { LayoutParams } from '../../config/LayoutParams';
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import { showInfo } from '../../components/Messages';

export default class ServicoDeNotificacaoView extends Component {
   constructor(props) {
      super(props);
      this.state = { mostrarAcessos: true };
      this.controller = new ServicoDeNotificacaoController(this);
   }

   renderizarFormulario = () => {
      let lang = this.props.lang;
      let tela = lang.telaDeCadastroDeServicoDeNotificacao;
      return (
         <React.Fragment>
            <Row>
               <Col sm={2} md={2} lg={2} xl={2}>
                  <FormGroup>
                     <Label>{lang.codigo}</Label>
                     <TextInput readOnly defaultValue={this.state.itemSelecionado.id} />
                  </FormGroup>
               </Col>

               <Col>
                  <FormGroup>
                     <Label>{tela.nome}</Label>
                     <TextInput
                        defaultValue={this.state.itemSelecionado.nome}
                        onChange={(e) => {
                           updateState(this, (state) => {
                              state.itemSelecionado.nome = e.target.value;
                           });
                        }}
                        upperCase={true}
                     />
                  </FormGroup>
               </Col>
            </Row>

            <Row>
               <Col sm={3} md={3} lg={3} xl={3}>
                  <FormGroup>
                     <Label>{tela.horaInicial}</Label>
                     <TimeInput
                        defaultValue={this.state.itemSelecionado.horaInicial}
                        onChange={(value) => {
                           updateState(this, (state) => {
                              state.itemSelecionado.horaInicial = value;
                           });
                        }}
                     />
                  </FormGroup>
               </Col>
               <Col sm={3} md={3} lg={3} xl={3}>
                  <FormGroup>
                     <Label>{tela.horaFinal}</Label>
                     <TimeInput
                        defaultValue={this.state.itemSelecionado.horaFinal}
                        onChange={(value) => {
                           updateState(this, (state) => {
                              state.itemSelecionado.horaFinal = value;
                           });
                        }}
                     />
                  </FormGroup>
               </Col>
               <Col>
                  <FormGroup>
                     <Label>{'Reinicid�ncia das notifica��es (minutos)'}</Label>
                     <IntegerInput
                        defaultValue={this.state.itemSelecionado.reincidencia}
                        onChange={(e) => {
                           updateState(this, (state) => {
                              state.itemSelecionado.reincidencia = e.floatValue;
                           });
                        }}
                     />
                  </FormGroup>
               </Col>
            </Row>

            <SubCadastro
               titulo={tela.destinatarios}
               itens={this.state.itemSelecionado.configuracoes}
               lang={lang}
               novo={() => {
                  return new Promise((resolve) => {
                     updateState(this, (state) => {
                        state.configuracaoSelecionada = {};
                     }).then(() => resolve());
                  });
               }}
               inserir={() => {
                  return new Promise((resolve, reject) => {
                     updateState(this, (state) => {
                        if (!state.itemSelecionado.configuracoes) {
                           state.itemSelecionado.configuracoes = [];
                        }
                        state.itemSelecionado.configuracoes.push(this.state.configuracaoSelecionada);
                     }).then(() => resolve());
                  });
               }}
               selecionarParaAlteracao={(index) => {
                  return new Promise((resolve) => {
                     updateState(this, (state) => {
                        state.configuracaoSelecionada = JSON.parse(
                           JSON.stringify(state.itemSelecionado.configuracoes[index])
                        );
                     }).then(() => resolve());
                  });
               }}
               alterar={(index) => {
                  return new Promise((resolve, reject) => {
                     updateState(this, (state) => {
                        state.itemSelecionado.configuracoes[index].nome = this.state.configuracaoSelecionada.nome;
                        state.itemSelecionado.configuracoes[index].telefone =
                           this.state.configuracaoSelecionada.telefone;
                        state.itemSelecionado.configuracoes[index].email = this.state.configuracaoSelecionada.email;
                        state.itemSelecionado.configuracoes[index].notificarViaSms =
                           this.state.configuracaoSelecionada.notificarViaSms;
                        state.itemSelecionado.configuracoes[index].notificarViaEmail =
                           this.state.configuracaoSelecionada.notificarViaEmail;
                        state.itemSelecionado.configuracoes[index].notificarViaLigacao =
                           this.state.configuracaoSelecionada.notificarViaLigacao;
                        state.itemSelecionado.configuracoes[index].notificarViaWhatsApp =
                           this.state.configuracaoSelecionada.notificarViaWhatsApp;

                        state.itemSelecionado.configuracoes[index].hierarquiaDeEnvioDeSms =
                           this.state.configuracaoSelecionada.hierarquiaDeEnvioDeSms;
                        state.itemSelecionado.configuracoes[index].hierarquiaDeEnvioDeEmail =
                           this.state.configuracaoSelecionada.hierarquiaDeEnvioDeEmail;
                        state.itemSelecionado.configuracoes[index].hierarquiaDeLigacao =
                           this.state.configuracaoSelecionada.hierarquiaDeLigacao;
                        state.itemSelecionado.configuracoes[index].hierarquiaDeWhatsApp =
                           this.state.configuracaoSelecionada.hierarquiaDeWhatsApp;
                     }).then(() => resolve());
                  });
               }}
               cancelar={() => {
                  return new Promise((resolve) => {
                     updateState(this, (state) => {
                        state.configuracaoSelecionada = null;
                     }).then(() => resolve());
                  });
               }}
               excluir={(index) => {
                  updateState(this, (state) => {
                     state.itemSelecionado.configuracoes.splice(index, 1);
                  });
               }}
               colunas={() => {
                  return [
                     { titulo: tela.nome, width: '30%', className: null },
                     { titulo: tela.telefone + '/E-mail', width: '25%', className: null },
                     { titulo: 'SMS', width: '15%', className: null },
                     { titulo: 'E-mail', width: '15%', className: null },
                     { titulo: tela.ligacao, width: '15%', className: null },
                     { titulo: 'WhatsApp', width: '15%', className: null },
                  ];
               }}
               linha={(item) => {
                  return [
                     item.nome,
                     [item.telefone, item.email].join('/'),
                     item.notificarViaSms ? this.props.lang.sim : '',
                     item.notificarViaEmail ? this.props.lang.sim : '',
                     item.notificarViaLigacao ? this.props.lang.sim : '',
                     item.notificarViaWhatsApp ? this.props.lang.sim : '',
                  ];
               }}
               acoes={(sender, index) => {
                  return (
                     <Fragment>
                        <IconButton
                           title={'Testar'}
                           style={{
                              fontSize: 23,
                              paddingTop: 3,
                              marginLeft: 5,
                              marginRight: 5,
                              color: LayoutParams.colors.corDosBotoesDoFormularioPadrao,
                           }}
                           cursor='pointer'
                           className='sub-cadastro-btn-alterar'
                           icon={faPlay}
                           onClick={() => {
                              var item = this.state.itemSelecionado.configuracoes[index];
                              this.props.api
                                 .post('/servicodenotificacao/enviarmensagemdeteste', { id: item.id })
                                 .then((result) => {
                                    showInfo(result);
                                 });
                           }}
                        />
                     </Fragment>
                  );
               }}
               formulario={() => {
                  return (
                     <Fragment>
                        <Row>
                           <Col>
                              <FormGroup>
                                 <Label>{tela.nome}</Label>
                                 <TextInput
                                    defaultValue={this.state.configuracaoSelecionada.nome}
                                    onChange={(e) => {
                                       updateState(this, (state) => {
                                          state.configuracaoSelecionada.nome = e.target.value;
                                       });
                                    }}
                                 />
                              </FormGroup>
                           </Col>
                           <Col>
                              <FormGroup>
                                 <Label>{tela.email}</Label>
                                 <EmailInput
                                    defaultValue={this.state.configuracaoSelecionada.email}
                                    onChange={(e) => {
                                       updateState(this, (state) => {
                                          state.configuracaoSelecionada.email = e.target.value;
                                       });
                                    }}
                                 />
                              </FormGroup>
                           </Col>
                           <Col>
                              <FormGroup>
                                 <Label>{tela.telefone}</Label>
                                 <TextInput
                                    defaultValue={this.state.configuracaoSelecionada.telefone}
                                    onChange={(e) => {
                                       updateState(this, (state) => {
                                          state.configuracaoSelecionada.telefone = e.target.value;
                                       });
                                    }}
                                    upperCase={true}
                                 />
                              </FormGroup>
                           </Col>
                        </Row>
                        <ListGroup style={{ width: 'fit-content' }}>
                           <ListGroup.Item className='pb-2'>
                              <FlexRow>
                                 <FlexCol width={200}>
                                    <FormGroup
                                       controlId='chknotificarViaEmail'
                                       style={{
                                          margin: 'auto',
                                          paddingTop: '5px',
                                          fontWeight: 'normal',
                                          width: '100%',
                                       }}
                                    >
                                       <CheckBox
                                          defaultChecked={
                                             this.state.configuracaoSelecionada.notificarViaEmail ? true : false
                                          }
                                          name='notificarViaEmail'
                                          label='E-mail'
                                          onChange={(checked) => {
                                             updateState(this, (state) => {
                                                state.configuracaoSelecionada.notificarViaEmail = checked;
                                             });
                                          }}
                                       />
                                    </FormGroup>
                                 </FlexCol>
                                 <FlexCol width={200}>
                                    <Select
                                       height={30}
                                       as='select'
                                       name='hierarquiaDeEnvioDeEmail'
                                       allowEmpty={false}
                                       defaultValue={this.state.configuracaoSelecionada.hierarquiaDeEnvioDeEmail}
                                       options={[
                                          { id: 1, descricao: tela.hierarquiaDeEnvio.imediato },
                                          { id: 2, descricao: tela.hierarquiaDeEnvio.segundaTentativa },
                                          { id: 3, descricao: tela.hierarquiaDeEnvio.terceiraTentativa },
                                          { id: 4, descricao: tela.hierarquiaDeEnvio.quartaTentativa },
                                       ]}
                                       getKeyValue={(i) => i.id}
                                       getDescription={(i) => i.descricao}
                                       onSelect={(i) => {
                                          updateState(this, (state) => {
                                             state.configuracaoSelecionada.hierarquiaDeEnvioDeEmail = i;
                                          });
                                       }}
                                    />
                                 </FlexCol>
                              </FlexRow>
                           </ListGroup.Item>

                           <ListGroup.Item className='pb-2'>
                              <FlexRow>
                                 <FlexCol width={200}>
                                    <FormGroup
                                       controlId='chknotificarViaWhatsApp'
                                       style={{
                                          margin: 'auto',
                                          paddingTop: '5px',
                                          fontWeight: 'normal',
                                          width: '100%',
                                       }}
                                    >
                                       <CheckBox
                                          defaultChecked={
                                             this.state.configuracaoSelecionada.notificarViaWhatsApp ? true : false
                                          }
                                          name='notificarViaWhatsApp'
                                          label='WhatsApp'
                                          onChange={(checked) => {
                                             updateState(this, (state) => {
                                                state.configuracaoSelecionada.notificarViaWhatsApp = checked;
                                             });
                                          }}
                                       />
                                    </FormGroup>
                                 </FlexCol>

                                 <FlexCol width={200}>
                                    <Select
                                       height={30}
                                       as='select'
                                       name='hierarquiaDeWhatsApp'
                                       allowEmpty={false}
                                       defaultValue={this.state.configuracaoSelecionada.hierarquiaDeWhatsApp}
                                       options={[
                                          { id: 1, descricao: tela.hierarquiaDeEnvio.imediato },
                                          { id: 2, descricao: tela.hierarquiaDeEnvio.segundaTentativa },
                                          { id: 3, descricao: tela.hierarquiaDeEnvio.terceiraTentativa },
                                          { id: 4, descricao: tela.hierarquiaDeEnvio.quartaTentativa },
                                       ]}
                                       getKeyValue={(i) => i.id}
                                       getDescription={(i) => i.descricao}
                                       onSelect={(i) => {
                                          updateState(this, (state) => {
                                             state.configuracaoSelecionada.hierarquiaDeWhatsApp = i;
                                          });
                                       }}
                                    />
                                 </FlexCol>
                              </FlexRow>
                           </ListGroup.Item>

                           <ListGroup.Item className='pb-2'>
                              <FlexRow>
                                 <FlexCol width={200}>
                                    <FormGroup
                                       controlId='chknotificarViaSms'
                                       style={{
                                          margin: 'auto',
                                          paddingTop: '5px',
                                          fontWeight: 'normal',
                                          width: '100%',
                                       }}
                                    >
                                       <CheckBox
                                          defaultChecked={
                                             this.state.configuracaoSelecionada.notificarViaSms ? true : false
                                          }
                                          name='notificarViaSms'
                                          label='SMS'
                                          onChange={(checked) => {
                                             updateState(this, (state) => {
                                                state.configuracaoSelecionada.notificarViaSms = checked;
                                             });
                                          }}
                                       />
                                    </FormGroup>
                                 </FlexCol>
                                 <FlexCol width={200}>
                                    <Select
                                       height={30}
                                       as='select'
                                       name='hierarquiaDeEnvioDeSms'
                                       allowEmpty={false}
                                       defaultValue={this.state.configuracaoSelecionada.hierarquiaDeEnvioDeSms}
                                       options={[
                                          { id: 1, descricao: tela.hierarquiaDeEnvio.imediato },
                                          { id: 2, descricao: tela.hierarquiaDeEnvio.segundaTentativa },
                                          { id: 3, descricao: tela.hierarquiaDeEnvio.terceiraTentativa },
                                          { id: 4, descricao: tela.hierarquiaDeEnvio.quartaTentativa },
                                       ]}
                                       getKeyValue={(i) => i.id}
                                       getDescription={(i) => i.descricao}
                                       onSelect={(i) => {
                                          updateState(this, (state) => {
                                             state.configuracaoSelecionada.hierarquiaDeEnvioDeSms = i;
                                          });
                                       }}
                                    />
                                 </FlexCol>
                              </FlexRow>
                           </ListGroup.Item>

                           <ListGroup.Item className='pb-2'>
                              <FlexRow>
                                 <FlexCol width={200}>
                                    <FormGroup
                                       controlId='chknotificarViaLigacao'
                                       style={{
                                          margin: 'auto',
                                          paddingTop: '5px',
                                          fontWeight: 'normal',
                                          width: '100%',
                                       }}
                                    >
                                       <CheckBox
                                          defaultChecked={
                                             this.state.configuracaoSelecionada.notificarViaLigacao ? true : false
                                          }
                                          name='notificarViaLigacao'
                                          label={tela.ligacao}
                                          onChange={(checked) => {
                                             updateState(this, (state) => {
                                                state.configuracaoSelecionada.notificarViaLigacao = checked;
                                             });
                                          }}
                                       />
                                    </FormGroup>
                                 </FlexCol>

                                 <FlexCol width={200}>
                                    <Select
                                       height={30}
                                       as='select'
                                       name='hierarquiaDeLigacao'
                                       allowEmpty={false}
                                       defaultValue={this.state.configuracaoSelecionada.hierarquiaDeLigacao}
                                       options={[
                                          { id: 1, descricao: tela.hierarquiaDeEnvio.imediato },
                                          { id: 2, descricao: tela.hierarquiaDeEnvio.segundaTentativa },
                                          { id: 3, descricao: tela.hierarquiaDeEnvio.terceiraTentativa },
                                          { id: 4, descricao: tela.hierarquiaDeEnvio.quartaTentativa },
                                       ]}
                                       getKeyValue={(i) => i.id}
                                       getDescription={(i) => i.descricao}
                                       onSelect={(i) => {
                                          updateState(this, (state) => {
                                             state.configuracaoSelecionada.hierarquiaDeLigacao = i;
                                          });
                                       }}
                                    />
                                 </FlexCol>
                              </FlexRow>
                           </ListGroup.Item>
                        </ListGroup>
                     </Fragment>
                  );
               }}
            />

            <br />
         </React.Fragment>
      );
   };

   render() {
      return (
         <FormularioPadrao
            titulo={this.props.lang.telaDeCadastroDeServicoDeNotificacao.titulo}
            url={'/servicodenotificacao'}
            api={this.props.api}
            lang={this.props.lang}
            ordenacaoPadrao={'nome'}
            permissoes={[1481, 1481, 1481, 1481]}
            getFiltro={this.controller.getFiltro}
            getTitulosDaTabela={this.controller.getTitulosDaTabela}
            getDadosDaTabela={this.controller.getDadosDaTabela}
            renderizarFormulario={this.renderizarFormulario}
            getObjetoDeDados={this.controller.getObjetoDeDados}
            antesDeInserir={this.controller.antesDeInserir}
            antesDeEditar={this.controller.antesDeEditar}
            antesDeSalvar={this.controller.antesDeSalvar}
            antesDeExcluir={this.controller.antesDeExcluir}
            getFormState={() => {
               return this.state;
            }}
            setFormState={(state, callback) => {
               return new Promise((resolve) => {
                  this.setState(state, () => {
                     resolve();
                     if (callback) {
                        callback();
                     }
                  });
               });
            }}
            select={this.props.select}
            form={this.props.form}
            itemVazio={{
               reincidencia: 30,
            }}
         />
      );
   }
}
